import { HttpService } from "@/core";
import { UnitSimpleListResp } from "../unit/unit.interface";
import {
  LibraryPageReq,
  LibraryPageResp,
  LibraryDetailResp,
  LibraryReq,
} from "./library.interface";
interface multipleDetail {
  ids: string[];
}

export class LibraryService {
  static usePageApi() {
    const api = (params: LibraryPageReq) =>
      HttpService.axios({
        method: "GET",
        url: "/material/page",
        params,
      });
    return HttpService.usePagination<LibraryPageResp>(api);
  }

  static useDetailApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "GET",
        url: `/material/${id}`,
      });
    return HttpService.useRequest<LibraryDetailResp>(api);
  }

  static useCreateApi() {
    const api = (data: LibraryReq) =>
      HttpService.axios({
        method: "POST",
        url: "/material",
        data,
      });
    return HttpService.useRequest<{ id: string }>(api);
  }

  static useEditApi() {
    const api = (id: string, data: LibraryReq) =>
      HttpService.axios({
        method: "PUT",
        url: `/material/${id}`,
        data,
      });
    return HttpService.useRequest<{ id: string }>(api);
  }

  static useDeleteApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "DELETE",
        url: `/material/${id}`,
      });
    return HttpService.useRequest<void>(api);
  }
  ///material/deleteBatch 材料库批量删除按钮
  static useDeleteMoreApi() {
    const api = (data:[]) =>
      HttpService.axios({
        method: "POST",
        url: `/material/deleteBatch`,
        data
      });
    return HttpService.useRequest<void>(api);
  }

  static useMultipleDetailApi() {
    const api = (data: multipleDetail) =>
      HttpService.axios({
        method: "POST",
        url: `/material/full/list`,
        data,
      });
    return HttpService.useRequest<void>(api);
  }

  static useImportPageApi() {
    const api = (url: string) =>
      HttpService.axios({
        method: "POST",
        url: `/material/import`,
        data: {
          url,
        },
      });
    return HttpService.useRequest<void>(api);
  }
  static useEnableApi() {
    const api = (id: string, enable: boolean) =>
      HttpService.axios({
        method: "PUT",
        url: `/material/${id}/enable`,
        data: {
          enable,
        },
      });
    return HttpService.useRequest<void>(api);
  }

  static useSimpleListApi() {
    const api = () =>
      HttpService.axios({
        method: "GET",
        url: "/unit/unitList",
      });
    return HttpService.useRequest<UnitSimpleListResp>(api);
  }
  static useUploadMaterial() {
    const api = (url) =>
      HttpService.axios({
        url: "/material/batchImportCheck",
        data: {
          url,
        },
        method: "post",
      });
    return HttpService.useRequest<any>(api);
  }

  static useFinishUpload() {
    const api = (data) =>
      HttpService.axios({
        url: "/material/batchImportCheckAddNew",
        data: {
          materialList: data,
        },
        method: "post",
      });
    return HttpService.useRequest<void>(api);
  }
}
